import { render, staticRenderFns } from "./MedicalCaregiver.template.vue?vue&type=template&id=316492ea&scoped=true&"
var script = {}
import style0 from "./MedicalCaregiver.template.vue?vue&type=style&index=0&id=316492ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316492ea",
  null
  
)

export default component.exports